import { ProgressProvider } from '@bprogress/react';

const BProgressProvider = ({ children }: { children: React.ReactNode }) => {
    return (
        <ProgressProvider
            height="4px"
            color="var(--color-primary)"
            options={{ showSpinner: false }}
            shallowRouting
        >
            {children}
        </ProgressProvider>
    );
};

export default BProgressProvider;
